import React from 'react'
import PropTypes from 'prop-types'

import styles from './input-error.css'
import lang from '@/lang'

const InputError = (props) => {
  const { visible = false, customClass = '', errorMessage = lang.generics.invalidInput } = props
  const visibleClass = visible ? styles.visible : styles.invisible

  return (
    <div className={`${styles.container} ${visibleClass} ${customClass || ''}`}>
      <span>{errorMessage}</span>
    </div>
  )
}

InputError.propTypes = {
  visible: PropTypes.bool,
  errorMessage: PropTypes.string,
  customClass: PropTypes.string,
}

export default InputError
